import type { Reducer } from 'redux';

import type { MediaLightboxHide, MediaLightboxShow } from '../../domains/mediaLightbox/actions.types';

import type { MediaLightbox } from './types';

export type MediaLightboxAction = MediaLightboxHide | MediaLightboxShow;

const initialState: MediaLightbox = {
  instance: undefined,
};

const reducer: Reducer<MediaLightbox, MediaLightboxAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'MEDIA_LIGHTBOX.SHOW':
      return {
        instance: action.payload,
      };
    case 'MEDIA_LIGHTBOX.HIDE':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
